import { CircularProgress, Container } from '@mui/material';
import SimpleAlert from '../../../../../components/display/SimpleAlert';
import useGetFeedbacks from '../hooks/useGetFeedbacks';
import FeedbackComponentWrapper from './FeedbackComponentWrapper';
import { CLINIC_FEEDBACKS_LIST } from '../../../../../enums/ApiPaths';

export default function ClinicFeedbacks() {
  const fetch = useGetFeedbacks(CLINIC_FEEDBACKS_LIST);
  const loading = fetch.isLoading
  const error = fetch.error

  if (loading) {
    return (
        <Container>
            <CircularProgress/>
        </Container>
    )
  } else if (!loading && error) {
    return (
        <Container>
            <SimpleAlert severity={"error"} message={"SomethingWentWrong"}/>
        </Container>
    )
  }

   return <FeedbackComponentWrapper 
            apiKey={CLINIC_FEEDBACKS_LIST} 
            fetch={fetch} 
            title={"ClinicFeedback"} 
            noDataMessage={"NoClinicFeedbacksFound"}/>;
}
